interface StatusIconProps {
  className?: string;
  onClick?: () => void;
  fillColor?: string;
}

export const StatusIcon = ({
  className,
  onClick,
  fillColor = "#00A3A3",
}: StatusIconProps) => (
  <svg
    width="12"
    height="13"
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
  >
    <circle cx="6" cy="6.5" r="6" fill={fillColor} />
  </svg>
);
